module.exports = __webpack_public_path__ + "img/container-monitoring.f72636c0.png";